'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _reactJss = require('react-jss');
var _reactJss2 = _interopRequireDefault(_reactJss);
var _CircularProgress = require('@material-ui/core/CircularProgress');
var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
var _reactI18next = require('react-i18next');
var _colorManipulator = require('@material-ui/core/styles/colorManipulator');
var _CustomModal = require('../CustomModal');
var _CustomModal2 = _interopRequireDefault(_CustomModal);
var _SponsorModalContent = require('../SponsorModalContent');
var _SponsorModalContent2 = _interopRequireDefault(_SponsorModalContent);
var _ResponsiveModes = require('../../constants/ResponsiveModes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var styles = {
  SponsorCards: {
    paddingTop: 60,
    paddingBottom: 60,
    color: function color(_ref) {
      var _color = _ref.otherProperties.color;
      return _color;
    },
    backgroundColor: function backgroundColor(_ref2) {
      var _backgroundColor = _ref2.otherProperties.backgroundColor;
      return _backgroundColor;
    }
  },
  loader: {
    display: 'block',
    margin: '2rem auto'
  },
  container: {
    margin: '0 auto',
    padding: '0 24px'
  },
  headerInfo: {
    marginBottom: 22
  },
  title: {
    textAlign: 'center',
    fontSize: 32,
    fontWeight: 'bold',
    margin: 0
  },
  componentDescription: {
    fontSize: 14,
    marginTop: 8,
    textAlign: 'center'
  },
  groupWrapper: {
    marginTop: 40
  },
  cardContainer: {
    padding: function padding(_ref3) {
      var responsiveMode = _ref3.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 16 : 24;
    },
    backgroundColor: function backgroundColor(_ref4) {
      var secondaryBackgroundColor = _ref4.otherProperties.secondaryBackgroundColor;
      return secondaryBackgroundColor;
    },
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'center',
    boxSizing: 'border-box',
    boxShadow: '0 3px 6px rgba(0, 0, 0, 0.16)',
    borderRadius: 10,
    position: 'relative',
    overflow: 'hidden'
  },
  categoryName: {
    margin: '0 0 25px 0',
    textAlign: 'center',
    textTransform: 'capitalize',
    fontSize: 16,
    fontWeight: 'bold',
    color: function color(_ref5) {
      var _color2 = _ref5.otherProperties.color;
      return (0, _colorManipulator.lighten)(_color2, 0.2);
    }
  },
  sponsorContainer: {
    height: function height(_ref6) {
      var responsiveMode = _ref6.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 'unset' : 60;
    },
    width: function width(_ref7) {
      var responsiveMode = _ref7.responsiveMode,
        itemsPerRowMobile = _ref7.otherProperties.itemsPerRowMobile;
      return responsiveMode === _ResponsiveModes.MOBILE ? itemsPerRowMobile == 12 ? 200 : 100 : 'unset';
    },
    margin: function margin(_ref8) {
      var responsiveMode = _ref8.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 16 : 24;
    },
    textAlign: 'center',
    cursor: 'pointer'
  },
  sponsorLogo: {
    height: function height(_ref9) {
      var responsiveMode = _ref9.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 'auto' : 60;
    },
    width: function width(_ref10) {
      var responsiveMode = _ref10.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? '100%' : 'auto';
    },
    maxWidth: function maxWidth(_ref11) {
      var responsiveMode = _ref11.responsiveMode;
      return responsiveMode === _ResponsiveModes.MOBILE ? 'unset' : '100%';
    }
  }
};
var SponsorCards = function (_Component) {
  _inherits(SponsorCards, _Component);
  function SponsorCards(props) {
    _classCallCheck(this, SponsorCards);
    var _this = _possibleConstructorReturn(this, (SponsorCards.__proto__ || Object.getPrototypeOf(SponsorCards)).call(this, props));
    _this.showModal = function (id) {
      _this.setState({
        currentSId: id
      });
    };
    _this.handleClose = function () {
      _this.setState({
        currentSId: 0
      });
    };
    _this.getOrderedSponsorCategories = function (categories) {
      if (!categories || Object.keys(categories).length === 0) return undefined;
      return Object.values(categories).sort(function (a, b) {
        return a.order - b.order;
      });
    };
    _this.renderSponsorsByCategory = function (sponsorCollection) {
      var title = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
      var classes = _this.props.classes;
      return _react2.default.createElement('div', {
        className: classes.groupWrapper
      }, title && _react2.default.createElement('p', {
        className: classes.categoryName
      }, title), _react2.default.createElement('div', {
        className: classes.cardContainer
      }, sponsorCollection.map(function (_ref12) {
        var sponsorName = _ref12.name,
          sponsorId = _ref12.id,
          logo = _ref12.logo;
        return logo && logo.filename ? _react2.default.createElement('div', {
          key: sponsorId,
          className: classes.sponsorContainer
        }, _react2.default.createElement('img', {
          onClick: function onClick() {
            return _this.showModal(sponsorId);
          },
          className: classes.sponsorLogo,
          src: logo.medium
        })) : null;
      })));
    };
    _this.state = {
      currentSId: 0
    };
    return _this;
  }
  _createClass(SponsorCards, [{
    key: 'render',
    value: function render() {
      var _this2 = this;
      var _props = this.props,
        classes = _props.classes,
        entities = _props.entities,
        pagination = _props.pagination,
        t = _props.t,
        responsiveMode = _props.responsiveMode,
        otherProperties = _props.otherProperties;
      var isFetching = pagination.isFetching;
      var descriptionText = otherProperties.descriptionText;
      var _ref13 = entities || {},
        events = _ref13.events,
        sponsors = _ref13.sponsors,
        sponsor_categories = _ref13.sponsor_categories;
      var orderedCategories = this.getOrderedSponsorCategories(sponsor_categories);
      var modalSponsor = void 0;
      if (!!this.state.currentSId && !!entities && !!entities.sponsors && entities.sponsors[this.state.currentSId]) {
        modalSponsor = entities.sponsors[this.state.currentSId];
      }
      var sponsorsWithoutCategory = Object.values(sponsors || []).filter(function (_ref14) {
        var category = _ref14.category;
        return !category.id;
      }).sort(function (a, b) {
        return a.name.localeCompare(b.name);
      });
      return _react2.default.createElement('div', {
        className: classes.SponsorCards
      }, !!this.state.currentSId && _react2.default.createElement(_CustomModal2.default, {
        onClose: this.handleClose,
        fixedWidth: true
      }, _react2.default.createElement(_SponsorModalContent2.default, {
        sponsor: modalSponsor
      })), isFetching ? _react2.default.createElement(_CircularProgress2.default, {
        className: classes.loader
      }) : sponsors && Object.keys(sponsors).length > 0 ? _react2.default.createElement('div', {
        className: classes.container,
        style: {
          maxWidth: '856px'
        }
      }, _react2.default.createElement('div', {
        className: classes.headerInfo
      }, _react2.default.createElement('p', {
        className: classes.title
      }, t('sponsors.title')), !!descriptionText && _react2.default.createElement('p', {
        className: classes.componentDescription
      }, descriptionText)), (orderedCategories || []).map(function (_ref15) {
        var categoryName = _ref15.name,
          categoryId = _ref15.id;
        var sponsorsByCategoryId = Object.values(sponsors).filter(function (_ref16) {
          var category = _ref16.category;
          return category.id === categoryId;
        }).sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        return _react2.default.createElement(_react2.default.Fragment, {
          key: categoryId
        }, _this2.renderSponsorsByCategory(sponsorsByCategoryId, categoryName));
      }), !!sponsorsWithoutCategory && sponsorsWithoutCategory.length > 0 && this.renderSponsorsByCategory(sponsorsWithoutCategory)) : _react2.default.createElement('h3', null, 'No Sponsors :('));
    }
  }]);
  return SponsorCards;
}(_react.Component);
exports.default = (0, _reactJss2.default)(styles)((0, _reactI18next.translate)('Misc')(SponsorCards));